<template src="./OrkReassurance.html"></template>
<style lang="scss" scoped src="./OrkReassurance.scss"></style>

<script>
import {
  SfIcon
} from '@storefront-ui/vue';
import icons from "@/utils/icons";
export default {
  name: 'OrkReassurance',
  components: {
    SfIcon
  },
  data() {
    return {
      icons,
      reassurance: [
        {
          text: 'Certified Quality',
          icon: icons.quality,
          link:'/qualite-trinitas'
        },
        {
          text: 'Free delivery from €300',
          icon: icons.freeDelivery,
          link:'/livraison'
        },
        {
          text: 'Secure payment',
          icon: icons.SecurePayment,
          link:'/questions-frequentes'
        },
        {
          text: 'Satisfied or refunded',
          icon: icons.Satisfied,
          link:'/echange-retour'

        }]
    }
  },
  methods: {}
};

</script>
